module.exports = __webpack_public_path__ + "img/languageOneActive.854af8a2.png";